module.exports = __webpack_public_path__ + "static/img/lefnire.94fc71b0.png";